import { render } from "./EmployeeThanks.vue?vue&type=template&id=5fc97bd5&scoped=true"
import script from "./EmployeeThanks.vue?vue&type=script&lang=js"
export * from "./EmployeeThanks.vue?vue&type=script&lang=js"

import "./EmployeeThanks.vue?vue&type=style&index=0&id=5fc97bd5&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc97bd5"]])

export default __exports__